import { State } from '@meraki-internal/state';
import { UserOnboardingState } from '../onboarding/UserOnboardingState';

export class CheckinsModalState extends State<{isOpen: boolean}> {
    static inject = () => [
        UserOnboardingState
    ];

    constructor(
        private userOnboardingState: UserOnboardingState
    ) {
        super({ isOpen: false });
    };

    setOpen = (isOpen: boolean) => {
        this.setState({ isOpen });

        if (isOpen && !this.userOnboardingState.isStepComplete('viewed-journal-summary')) {
            this.userOnboardingState.completeStep('viewed-journal-summary');
        }
    };

    isOpen = () => {
        return Boolean(this.state?.isOpen);
    };
};
